module.exports = __webpack_public_path__ + "media/11_7.2401b4f4.wav";